import { createTheme } from "@mui/material";

export const createButtonComponentTheme = createTheme({
    components: {
        /* Button component overrides */
        MuiButton: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true,
            },
        },
        /* IconButton component overrides */
        MuiIconButton: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
});
